export const STAGE_HISTORY_AND_LOGS_TAB = 'Stage History & logs';
